export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="footer"
      className="relative bg-[#f9f2e0] text-[#1c1811] py-16 border-t border-[#1c1811]/20"
    >
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <a
          href="#top"
          className="font-serif tracking-tight leading-none flex flex-col"
        >
          <span className="text-[10px] uppercase tracking-[0.25em] text-[#a1802f] mb-1 font-sans">
            Académie
          </span>
          <span className="text-2xl md:text-3xl leading-none">
            Conseils <span className="text-[#D90429]">&amp;</span> Réussites
          </span>
          <span className="text-xs text-[#1c1811]/50 mt-3 font-sans tracking-wide">
            Anabela Moreira
          </span>
        </a>

        <p className="text-[#1c1811]/60 text-sm text-center max-w-sm mx-auto">
          Redonner du sens à votre vie professionnelle grâce à une méthode en
          cinq étapes.
        </p>

        <a
          href="https://calendly.com/contact-conseils-et-reussites-academie/entretien-prive-clarte" target="_blank" rel="noopener noreferrer"
          data-testid="footer-cta"
          className="group inline-flex items-center justify-center gap-2 bg-[#d4a94a] hover:bg-[#b3892f] px-6 py-3 text-xs uppercase tracking-[0.15em] text-[#1c1811] transition-colors duration-300 whitespace-nowrap justify-self-end"
        >
          Réserver votre entretien
          <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
            &rarr;
          </span>
        </a>
      </div>
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 mt-10 pt-6 border-t border-[#1c1811]/15 text-xs text-[#1c1811]/40 flex flex-col md:flex-row justify-between gap-2">
        <span>© {new Date().getFullYear()} Académie Conseils &amp; Réussites — Anabela Moreira.</span>
        <span>Accompagnement professionnel</span>
      </div>
    </footer>
  );
}
